var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"recommTitle"},[_vm._v("相关课程推荐")]),_c('Item',{attrs:{"ExcellentClassList":_vm.ExcellentClassList,"type":"recomm"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }